import {
  Box,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
} from '@mui/material';
import styles from './ccf-contact-history-table-header.module.scss';
import { visuallyHidden } from '@mui/utils';

type Order = 'asc' | 'desc';

interface HeadCell {
  id: string;
  label: string;
}

const headCells: readonly HeadCell[] = [
  {
    id: 'time',
    label: 'Time',
  },
  {
    id: 'customer',
    label: 'Customer',
  },
  {
    id: 'status',
    label: 'Status',
  },
  {
    id: 'skill',
    label: 'Skill',
  },
  {
    id: '',
    label: '',
  },
];

const headCellsSmView: readonly HeadCell[] = [
  {
    id: 'time',
    label: 'Time',
  },
  {
    id: 'customer',
    label: 'Customer',
  },
  {
    id: 'status',
    label: 'Status',
  },
];

/* eslint-disable-next-line */
export interface CcfContactHistoryTableHeaderProps {
  order: Order;
  orderBy: string;
  onRequestSort: any;
  isAppSpace: boolean;
}

/**
 * used to show contact history Table Header
 * @param props - CcfContactHistoryTableHeaderProps
 * @example ` <CcfContactHistoryTableHeader />`
 */
export function CcfContactHistoryTableHeader(
  props: CcfContactHistoryTableHeaderProps
) {
  const { order, orderBy, onRequestSort, isAppSpace } = props;

  /**
   * Used to handle sort
   * @param event -React.SyntheticEvent
   * @param reason -string
   * @example - createSortHandler()
   */
  const createSortHandler =
    (property: any) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property);
    };

  return (
    <TableHead>
      <TableRow>
        {(!isAppSpace ? headCells : headCellsSmView).map((headCell) => (
          <TableCell
            key={headCell.id}
            // align="center"
            sortDirection={orderBy === headCell.id ? order : false}
            className={styles.tableheader}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
              className={styles.label}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

export default CcfContactHistoryTableHeader;
